"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBreakdownCount = exports.getAddOnSurveyTotalOreGroup = exports.getDraftSurveyTotalOreGroup = exports.getIntermediateSurveyTotalOreGroup = exports.getShoreScaleTonsPerHatchGroup = exports.getShoreScaleTons = exports.findLastVessel = exports.findActiveVessels = exports.sortVessels = exports.findVesselEndDate = exports.findVesselStartDate = void 0;
const moment_1 = __importDefault(require("moment"));
const model_1 = require("../proto/model");
const sortVesselActivities_1 = require("./sortVesselActivities");
const sortVesselHatchActivities_1 = require("./sortVesselHatchActivities");
const proto_1 = require("../proto");
function findVesselStartDate(vessel) {
    const rs = vessel === null || vessel === void 0 ? void 0 : vessel.reclaimStart;
    return moment_1.default(rs);
}
exports.findVesselStartDate = findVesselStartDate;
function findVesselEndDate(vessel) {
    let endDate = null;
    const vesselActivities = vessel.activities;
    if (vesselActivities) {
        const sortedActivities = sortVesselActivities_1.SortVesselActivities(vesselActivities);
        if (sortedActivities.length > 0) {
            const last = sortedActivities[sortedActivities.length - 1];
            return sortVesselActivities_1.findVesselActivityEndDate(last);
        }
    }
    endDate = moment_1.default(vessel === null || vessel === void 0 ? void 0 : vessel.reclaimStart);
    return endDate;
}
exports.findVesselEndDate = findVesselEndDate;
function sortVessels(vessels) {
    return Object.values(vessels).sort((vesselActivityA, vesselActivityB) => {
        const ma = findVesselStartDate(vesselActivityA);
        const mb = findVesselEndDate(vesselActivityB);
        if (ma && mb) {
            const isAfter = ma.isBefore(mb);
            const isEqual = ma.isSame(mb, 'minute');
            if (isAfter) {
                return -1;
            }
            else if (isEqual) {
                return 0;
            }
            else {
                return 1;
            }
        }
        else {
            throw new Error('a date is undefined');
        }
    });
}
exports.sortVessels = sortVessels;
function findActiveVessels(vessels
//TODO user
) {
    const sortedVessels = sortVessels(vessels);
    return sortedVessels.filter((sv) => sv.state === model_1.VesselState.VESSEL_STATE_IN_PROGRESS);
}
exports.findActiveVessels = findActiveVessels;
function findLastVessel(vessels, excludeId, berth) {
    const sortedVessels = sortVessels(vessels);
    let filteredByBerth = sortedVessels;
    if (berth) {
        filteredByBerth = filteredByBerth.filter((v) => {
            return v.berth === berth;
        });
    }
    if (excludeId) {
        //gets vesselToExclude
        const thisVessel = vessels[excludeId];
        let thisVesselStartDate = moment_1.default();
        if (thisVessel) {
            //this will ensure that it only checks vessels pre this vessel
            thisVesselStartDate = findVesselStartDate(thisVessel);
        }
        else {
            throw new Error('thisVessel does not exist check sortVessels.ts');
        }
        const filtered = filteredByBerth
            .filter((vessel) => {
            return vessel.id !== excludeId;
        })
            .filter((vessel) => {
            const vStartDate = findVesselStartDate(vessel);
            return vStartDate.isBefore(thisVesselStartDate);
        });
        return filtered.length > 0 ? filtered[filtered.length - 1] : null;
    }
    return filteredByBerth.length > 0
        ? filteredByBerth[filteredByBerth.length - 1]
        : null;
}
exports.findLastVessel = findLastVessel;
function getShoreScaleTons(vessel) {
    //Sum of all the loading and direct loading tons
    //Loading and direct loading is only on hatch group
    //Extract all hatch groups
    let totalTons = 0;
    sortVesselActivities_1.SortVesselActivities(vessel.activities)
        .filter(({ vesselHatchActivityGroup }) => vesselHatchActivityGroup !== undefined)
        .forEach((va) => {
        const vhag = va.vesselHatchActivityGroup;
        if (vhag) {
            if (vhag === null || vhag === void 0 ? void 0 : vhag.completed) {
                totalTons += vhag.completed.hatchTons;
            }
        }
    });
    return totalTons;
}
exports.getShoreScaleTons = getShoreScaleTons;
function sortShoreScalePerHatchGroup(shoreScale) {
    return shoreScale.sort((a, b) => {
        const aNr = a.hatchNumber;
        const bNr = b.hatchNumber;
        if (aNr && bNr) {
            if (aNr > bNr) {
                return 1;
            }
            else if (aNr === bNr) {
                return 0;
            }
            else {
                return -1;
            }
        }
        else {
            throw new Error('An error occured');
        }
    });
}
function getShoreScaleTonsPerHatchGroup(vessel) {
    const hatchNumbersAndTons = sortVesselActivities_1.SortVesselActivities(vessel.activities)
        .filter(({ vesselHatchActivityGroup }) => vesselHatchActivityGroup !== undefined)
        .map((act) => {
        var _a, _b, _c, _d, _e;
        return {
            hatchNumber: (_b = (_a = act.vesselHatchActivityGroup) === null || _a === void 0 ? void 0 : _a.hatchNumber) !== null && _b !== void 0 ? _b : 0,
            hatchTons: (_e = (_d = (_c = act.vesselHatchActivityGroup) === null || _c === void 0 ? void 0 : _c.completed) === null || _d === void 0 ? void 0 : _d.hatchTons) !== null && _e !== void 0 ? _e : 0,
        };
    });
    const hatchNumbersAndTonsTotal = hatchNumbersAndTons.reduce((result, { hatchNumber, hatchTons }) => {
        if (result.get(hatchNumber)) {
            result.get(hatchNumber).hatchTons += hatchTons;
        }
        else {
            result.set(hatchNumber, { hatchNumber, hatchTons });
        }
        return result;
    }, new Map());
    const result = [
        ...hatchNumbersAndTonsTotal.values(),
    ];
    const sortedResult = sortShoreScalePerHatchGroup(result);
    return sortedResult;
}
exports.getShoreScaleTonsPerHatchGroup = getShoreScaleTonsPerHatchGroup;
function getIntermediateSurveyTotalOreGroup(vessel) {
    const sortedSurveyActivities = sortVesselActivities_1.SortVesselActivities(vessel.activities)
        .filter(({ surveyActivity }) => surveyActivity !== undefined)
        .filter((va) => {
        const sa = va.surveyActivity;
        if (sa) {
            if (sa.surveyType === proto_1.SurveyType.SURVEY_TYPE_INTERMEDIATE_SURVEY) {
                return sa;
            }
        }
    });
    const surveyActivities = sortedSurveyActivities.map((sa) => {
        var _a, _b, _c;
        return {
            startDate: (_a = sa.startDate) !== null && _a !== void 0 ? _a : new Date(),
            oreGroup: (_c = (_b = sa.surveyActivity) === null || _b === void 0 ? void 0 : _b.oreGroup) !== null && _c !== void 0 ? _c : [],
        };
    });
    return surveyActivities;
}
exports.getIntermediateSurveyTotalOreGroup = getIntermediateSurveyTotalOreGroup;
function getDraftSurveyTotalOreGroup(vessel) {
    const oreGroups = [];
    sortVesselActivities_1.SortVesselActivities(vessel.activities)
        .filter(({ surveyActivity }) => surveyActivity !== undefined)
        .forEach((va) => {
        const sa = va.surveyActivity;
        if (sa) {
            if (sa.surveyType === proto_1.SurveyType.SURVEY_TYPE_DRAFT_SURVEY) {
                sa.oreGroup.forEach((og) => oreGroups.push(og));
            }
        }
    });
    const finalOreGroups = [];
    for (const og of oreGroups) {
        const internalOgs = finalOreGroups.map((og) => og.oreType);
        const itemIndex = internalOgs.indexOf(og.oreType);
        if (itemIndex === -1) {
            finalOreGroups.push(og);
        }
        else {
            finalOreGroups[itemIndex].oreTons += og.oreTons;
        }
    }
    return finalOreGroups;
}
exports.getDraftSurveyTotalOreGroup = getDraftSurveyTotalOreGroup;
function getAddOnSurveyTotalOreGroup(vessel) {
    const oreGroups = [];
    sortVesselActivities_1.SortVesselActivities(vessel.activities)
        .filter(({ surveyActivity }) => surveyActivity !== undefined)
        .forEach((va) => {
        const sa = va.surveyActivity;
        if (sa) {
            if (sa.surveyType === proto_1.SurveyType.SURVEY_TYPE_ADD_ON_SURVEY) {
                sa.oreGroup.forEach((og) => oreGroups.push(og));
            }
        }
    });
    const finalOreGroups = [];
    for (const og of oreGroups) {
        const internalOgs = finalOreGroups.map((og) => og.oreType);
        const itemIndex = internalOgs.indexOf(og.oreType);
        if (itemIndex === -1) {
            finalOreGroups.push(og);
        }
        else {
            finalOreGroups[itemIndex].oreTons += og.oreTons;
        }
    }
    return finalOreGroups;
}
exports.getAddOnSurveyTotalOreGroup = getAddOnSurveyTotalOreGroup;
function getBreakdownCount(vessel) {
    let breakdownCount = 0;
    const vs = sortVesselActivities_1.SortVesselActivities(vessel.activities);
    vs.forEach(({ nonHatchBreakdownActivity, vesselHatchActivityGroup }) => {
        if (nonHatchBreakdownActivity) {
            breakdownCount++;
        }
        else if (vesselHatchActivityGroup) {
            const vhagActivities = sortVesselHatchActivities_1.sortVesselHatchActivities(vesselHatchActivityGroup);
            vhagActivities.map(({ hatchBreakdownActivity }) => {
                if (hatchBreakdownActivity) {
                    breakdownCount++;
                }
            });
        }
    });
    return breakdownCount;
}
exports.getBreakdownCount = getBreakdownCount;
